module.exports = __webpack_public_path__ + "img/护理-10.2ce14995.png";